// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconLayers1 = createRemixIcon('IconLayers1', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.607.907L12 .57l-.607.337l-9 5L.426 7l1.967 1.092l2.95 1.64L.5 12.5l4.705 2.454L.5 17.643l11.5 6l11.5-6l-4.705-2.689L23.5 12.5l-4.844-2.768l2.951-1.64L23.574 7l-1.967-1.093zM12 10.57L5.574 7L12 3.43L18.426 7z\" clip-rule=\"evenodd\"/>");
